// Dependencies
// -----------------------------------------------
import React from 'react';
import styled from 'styled-components';
import 'react-dates/initialize'; // Needed for rendering any react-dates components
import { connect } from 'react-redux';

// Components
// -----------------------------------------------
import displayError from '../errors/display';
import Form from './form';
import Message from './message';
import BookingHeader from './booking-header';
import Notification from '../miscellaneous/notification';
import Ripple from '../miscellaneous/ripple';
import { fetchWlsReceipt, postWlsReview } from '../../utils/wls-api-client';

// Styles
// -----------------------------------------------
const ReviewPage = styled.div`
  background: var(--base-color-off-white, #f8f9f9);
  min-height: calc(100vh - 350px);
`;

const ReviewContainer = styled.div`
  padding: 56px 16px 80px;
  max-width: 680px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 600px) {
    padding: 32px 12px 56px;
  }
`;

// -----------------------------------------------
// COMPONENT->REVIEW -----------------------------
// -----------------------------------------------
class Review extends React.Component {
  // Constructor
  // ---------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      rating: 0,
      title: null,
      body: null,
      review: null,
      booking: null,
      incomplete: true,
      loading: false
    };
  }

  // Lifecycle
  // ---------------------------------------------
  componentDidMount() {
    fetchWlsReceipt(this.props.brand, this.props.match.params.booking_code)
      .then(response => {
        if (response.data && response.data.booking) {
          this.setState({ booking: response.data });
        }
      })
      .catch(() => {
        // Booking details are supplementary; the review form still works
        // without them, so a failed lookup is silently ignored.
      });
  }

  // Validate Fields
  // ---------------------------------------------
  validateFields = () => {
    if (this.state.title && this.state.body && this.state.rating > 0) {
      this.setState({ incomplete: false });
    }
  };

  // On Change
  // ---------------------------------------------
  onChange = (name, value) => {
    const changeState = {};

    changeState[name] = value;
    this.setState(changeState, this.validateFields());
  };

  // On Submit
  // ---------------------------------------------
  onSubmit = () => {
    this.setState({ loading: true, incomplete: true });
    postWlsReview(this.props.brand, {
      booking_code: this.props.match.params.booking_code,
      rating: this.state.rating,
      title: this.state.title,
      body: this.state.body
    })
      .then(response => {
        this.setState({ review: response.data.review, loading: false });
      })
      .catch(error => {
        displayError({ message: 'Review was unable to submit', error });
        this.setState({ loading: false, incomplete: false });
      });
  };

  // Render Review Form
  // ---------------------------------------------
  renderReviewForm = () => (
    <Form
      onChange={this.onChange}
      onWysiwygChange={this.onChange}
      onSubmit={this.onSubmit}
      rating={this.state.rating}
      title={this.state.title}
      incomplete={this.state.incomplete}
    />
  );

  // Render Message
  // ---------------------------------------------
  renderMessage = () => <Message error={this.state.error} />;

  // Render Loading
  // ---------------------------------------------
  renderLoading = () => <Ripple color="#50E3C2" />;

  // Render
  // ---------------------------------------------
  render() {
    return (
      <>
        <Notification />
        <ReviewPage>
          <ReviewContainer>
            {!this.state.review && (
              <BookingHeader booking={this.state.booking} />
            )}
            {this.state.review ? this.renderMessage() : this.renderReviewForm()}
            {this.state.loading ? this.renderLoading() : null}
          </ReviewContainer>
        </ReviewPage>
      </>
    );
  }
}

export default connect(state => ({ brand: state.brand }))(Review);
